@if (!datasetACS.loading.value) {
  @if (!custom_input) {
    <div [ngClass]="is_pickup && activated ? 'pickup' : ''" class="resource-row fx-row fx-wrap fx-justify-start fx-items-center" style="gap: 8px">
      <div (click)='changeStatus()' [matTooltip]='not_activable_reason' class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
        @if (!activated) {
          <button class="checkbox" [disabled]='not_activable_reason || is_primary || parent_resource' mat-icon-button [matTooltip]='is_primary?"Risorsa primaria NON attiva":"Risorsa opzionale NON attivata" | translate'>
            <mat-icon>check_box_outline_blank</mat-icon>
          </button>
        }
        @if (activated) {
          <button class="checkbox" [disabled]='not_activable_reason || is_primary || parent_resource' mat-icon-button [matTooltip]='is_primary?"Risorsa primaria attiva":"Risorsa opzionale attivata" | translate'>
            <mat-icon>check_box</mat-icon>
          </button>
        }
        <div class="fx-row fx-justify-space-between fx-items-center" style="cursor: pointer">
          <span class="ml-4 info_resource fx-row fx-justify-start fx-items-center" style="gap: 8px">
            <span class="resource_description">@if (parent_resource) {
              <span>{{parent_resource.description}}: </span>
            } {{trip_resource.description}}</span>
            <span class="text-color-black font-size-14">{{datasetRS.record.value.total_amount | currency:'EUR' }}</span>
            @if (is_pickup) {
              <span class="pickup">PICK-UP</span>
            }
            @if (!is_primary) {
              <span class='secondary-text mat-caption ml-4'>({{ 'Opzionale' | translate}})</span>
            }
          </span>
        </div>
      </div>
      @if (is_pickup && activated) {
        <div class="resource_meeting_point fx-row fx-justify-start fx-items-center" style="gap: 8px">
          <mat-icon>place</mat-icon>
          <span class='ml-4 mr-4'>{{'Punto di ritrovo' | translate}}: @if (tripBookingResourceService.meetingPointPickupResource) {
            <span class='meeting_point_description' [matTooltip]='tripBookingResourceService.meetingPointPickupResource.description'>{{tripBookingResourceService.meetingPointPickupResource.description}}</span>
          }</span>
          <span>@if (tripBookingResourceService.loadPickupMeetingPoint) {
            <mat-spinner diameter='20'></mat-spinner>
          }</span>
          @if (!tripBookingResourceService.loadPickupMeetingPoint) {
            <button mat-icon-button color='accent' [matTooltip]='"Modifica punto di ritrovo" | translate' (click)='tripBookingResourceService.editMeetingPoint(datasetRS.record.value)'>
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  }
  @if (custom_input && datasetRS.record.value.data) {
    <div class="resource-row">
      <span class="ml-4 info_resource fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <span class="resource_description">{{trip_resource.description}}</span>
      </span>
    </div>
  }
  @if ((is_primary && activated) || custom_input && activated) {
    @if (datasetRS.record.value.data && datasetRS.record.value.data.data.custom_inputs) {
      <div class="primary-input">
        @for (input of datasetRS.record.value.data.data.custom_inputs; track input) {
          <div class="fx-row" style="gap: 10px">
            @if (datasetRS.record.value.data.details) {
              <span> <strong>{{input.label['it']}}</strong> : {{datasetRS.record.value.data.details[input.name]}}</span>
            }
          </div>
        }
      </div>
    }
  }
}
